'use strict';
angular.module('xp-element-header', ['angularWidget', 'client.services'])
  .controller('clientHeaderElementCtrl', ['$scope', 'widgetConfig', '$http', '$timeout', function ($scope, widgetConfig, $http, $timeout) {
	   
		// The element is the block of data provided by the source xml
		$scope.options = widgetConfig.getOptions($scope);
		$scope.format = "plain";
	  
		var parseElement = function()
		{
			if (!$scope.options.element || !$scope.options.element.config || !$scope.options.element.config.attributes)
				return;
			
			$scope.options.element.config.attributes.forEach(function(attribute)
			{
				switch (attribute.name)
				{
				case "style" : 
					$scope.format = attribute.value;
				break;
				case "style_options" : 
					$scope.format = attribute.value;
				break;
				}
			});
			$timeout(function() {
				// Notify the widget that were are done loading the data
				widgetConfig.exportProperties({elementId: $scope.options.element.id, readyToDisplay: true});
			});
		};
		
		$scope.$watch('options', parseElement, true);

  }]);